export default "__VITE_ASSET__CCh4KOFT__"